module.exports = __webpack_public_path__ + "static/nz-festival-arts-811657454da40e41e19e1dab5df23f87.png";